export default {
  currentIssuer: state => state.current,
  instances: state => state.instances,
};
